export default __webpack_public_path__ + "ae57bd9a2dc0d4b4783cbdfbd04bece3.png";